import { Link } from "react-router-dom";
import { ITAAS_INSTITUTION } from "@itaas/pep-contracts";
import { SiteLayout } from "../components/layout/SiteLayout";
import { SeoHead } from "../components/seo/SeoHead";
import { usePepI18n } from "../i18n/usePepI18n";

/**
 * Privacy overview — institutional contact facts only.
 * Full legal DPA/cookie policy drafting is out of PEP-2 scope.
 */
export function PrivacyPage() {
  const { locale } = usePepI18n();
  const en = locale === "en";

  return (
    <SiteLayout>
      <SeoHead
        title={en ? "Privacy" : "Confidentialité"}
        description={
          en
            ? "How ITaaS RDC handles contact and commercial data on the ITaaS Suite product site."
            : "Comment ITaaS RDC traite les données de contact et commerciales sur le site ITaaS Suite."
        }
        canonicalPath="/privacy"
        locale={locale}
      />
      <div className="pep-page-hero py-5 mb-0">
        <div className="container">
          <h1 className="display-5 fw-bold mb-2">{en ? "Privacy" : "Confidentialité"}</h1>
          <p className="lead mb-0 opacity-90">
            {en ? "Data controller identity" : "Identité du responsable de traitement"}
          </p>
        </div>
      </div>
      <div className="container py-5">
        <div className="col-lg-8">
          <p>
            {en
              ? "Commercial forms on this site (contact, trial, affiliation) are operated by ITaaS RDC for the purpose of responding to your requests and managing product evaluations."
              : "Les formulaires commerciaux de ce site (contact, essai, affiliation) sont opérés par ITaaS RDC afin de répondre à vos demandes et de gérer les évaluations produit."}
          </p>
          <p className="mb-1">
            <strong>{ITAAS_INSTITUTION.legalName}</strong> ({ITAAS_INSTITUTION.brandName})
          </p>
          <p className="mb-1">
            <a href={`mailto:${ITAAS_INSTITUTION.email}`}>{ITAAS_INSTITUTION.email}</a>
          </p>
          <p className="mb-3">
            <a href={`tel:${ITAAS_INSTITUTION.telephoneTel}`}>{ITAAS_INSTITUTION.telephone}</a>
          </p>
          <p className="small text-secondary">
            {en
              ? "A detailed privacy / cookie policy may be published later. This page establishes the controller identity and contact channel."
              : "Une politique de confidentialité / cookies détaillée pourra être publiée ultérieurement. Cette page établit l’identité du responsable et le canal de contact."}
          </p>
          <p className="mb-0">
            <Link to="/legal">{en ? "Legal notice" : "Mentions légales"}</Link>
            {" · "}
            <Link to="/contact">{en ? "Contact" : "Contact"}</Link>
          </p>
        </div>
      </div>
    </SiteLayout>
  );
}
